<script>
  export let destroy
  export let themeName
  export let clearFileTree
  export let bulkUpload
  export let reloadTree
  import { tick } from "svelte"

  let hovering = false
  let zipFileName = ""
  let showThumb = false
  let dzHidden = true
  let messages = []
  let showUploadBtn = true
  let zipFiles = []
  let logDiv = null

  const lastMessage = `ALL DONE! 👏 🎉 \n click 'cancel' to continue`
  async function drop(e) {
    const files = Array.from(e.target.files || e.dataTransfer.files)
    const zips = files.filter(
      ({ name, type }) =>
        name.indexOf(".zip") > -1 && /\/zip|\/x-zip/.test(type)
    )
    showUploadBtn = false
    if (zips.length) {
      const [{ name } = {}] = files
      zipFileName = name
      zipFiles = await Promise.all(zips.map(async file => await _handler(file)))
      addMessage(`Found ${zipFiles[0].length} folders/files `)
      setTimeout(() => {
        showThumb = true
      }, 100)
      dzHidden = false
    }
    /**
     * overwite files
     * @function _overwriteFiles
     */
    function _overwriteFiles() {
      let defaultTree = require("../default_tree").tree
      let allNodes = tree.findAll(n => n.key !== "tephra" && !n.data.tephra)
      allNodes.filter(node => node.key)
    }
  }

  async function overwiteFilesClick(e) {
    try {
      addMessage(`restoring theme to barebones structure 👻...`)
      await clearFileTree()
      reloadTree()
      addMessage(`✅`)
      const [folder] = zipFiles
      const validatedFiles = validateFolder(folder)
      if (validatedFiles) {
        const scssFiles = validatedFiles.filter(f => /\.scss$/i.test(f.path))
        scssFiles.sort(f => (f.reference === "variables.scss" ? -1 : 1))
        const allFiles = validatedFiles
          .filter(f => !/\.scss$/i.test(f.path))
          .concat(scssFiles)
        console.log({ allFiles })
        await bulkUpload(allFiles, false, addMessage)
        addMessage("ALL DONE !")
        reloadTree()
      } else {
        addMessage(
          `❌ This zip file strcuture isn't accepted, make sure the assets, templates and layouts folders are on the top level of your zip ❌`
        )
      }
    } catch (error) {
      addMessage("Failed to create barebones structure, check console for info")
      console.error("dz_err::", error)
    }
  }

  /**
   * @function _handler
   * @param  {type} f {description}
   * @return {type} {description}
   */
  async function _handler(f) {
    try {
      const { default: JSZipLib } = await import(
        /* webpackChunkName: "jsZip" */ "jszip"
      )
      let JSZip = new JSZipLib()
      let zip = await JSZip.loadAsync(f)
      let nodes = []
      try {
        await Promise.all(
          Object.entries(zip.files).map(async index => {
            const zipEntry = index[1]
            if (zipEntry) {
              const blob = await zipEntry.async("blob")
              const content = await zipEntry.async("string")
              nodes.push({ path: zipEntry.name, content, blob })
            }
          })
        )
      } catch (error) {
        console.error(error)
      }
      return nodes
    } catch (error) {
      console.log("jszip failed to load", error)
    }
  }

  function validateFolder(folder) {
    const filtered = folder.filter(
      ({ path }) => !/_macosx/gi.test(path) && !/\.ds_store/gi.test(path)
    )
    const score = filtered.reduce(
      (score, { path = "" }) =>
        /^assets\/$|^templates\/$|^layouts\/$/i.test(path) ? score + 1 : score,
      0
    )

    if (score !== 3) return false

    return filtered
  }

  async function addMessage(msg) {
    messages = messages.concat(msg)
    await tick()
    if (logDiv) logDiv.scrollTo(0, logDiv.scrollHeight)
  }
</script>

<style id="document_dropzone_style">
  #document_dropzone {
    display: none;
  }
  #files_input {
    position: absolute;
    left: 0;
    top: 0;
    visibility: hidden;
  }
  #document_dropzone.show {
    display: block;
  }
  #document_dropzone #dz_label {
    display: flex;
    position: fixed;
    z-index: 9999999;
    background: rgba(229, 124, 41, 0.2);
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    justify-content: center;
    align-items: center;
    border: none;
    box-shadow: none;
    flex-direction: column;
  }
  #document_dropzone #dz_label button {
    color: #fff;
    background: rgb(229, 124, 41);
    padding: 10px 15px;
    border: none;
    margin: 10px;
  }
  #dz_thumbnail {
    display: none;
  }
  #dz_thumbnail .fa {
    display: block;
    font-size: 80px;
    background: rgb(229, 124, 42);
    padding: 20px;
    color: #fff;
    width: 110px;
    margin: 0 auto;
    position: relative;
    top: 100vh;
  }
  #dz_thumbnail #dz_file_name {
    opacity: 0;
    color: #fff;
    font-family: monospace;
    padding: 0 8px;
    font-weight: 600;
    font-size: 17px;
    transition: 0.3s opacity;
  }
  #dz_thumbnail #dz_file_name.showThumb {
    opacity: 1;
  }
  .dzHidden {
    display: none;
  }
  .dz_ctas {
    display: flex;
  }

  .dz_log {
    max-height: 500px;
    width: 600px;
    background: rgba(0, 0, 0, 0.4);
    color: #fff;
    overflow: auto;
    padding: 10px;
    overflow-anchor: auto;
  }
</style>

<div
  id="document_dropzone"
  class="show"
  on:drop|preventDefault={drop}
  ondragover="return false"
  on:dragenter={() => (hovering = true)}
  on:dragleave={() => (hovering = false)}>
  <form id="document_dropzone_form">
    <label for="files_input" id="dz_label" on:drop|preventDefault={drop}>
      <div id="dz_thumbnail">
        <i class="fa fa-file-archive-o" />
        <h3 id="dz_file_name" class:showThumb>{zipFileName}</h3>
      </div>
      <div class="dz_ctas">
        {#if showUploadBtn}
          <button
            id="dz_upload_btn"
            type="button"
            on:click={() => {
              document.querySelector('#document_dropzone label').click()
            }}>
            Upload a .zip file to "{themeName}"
          </button>
        {/if}
        <div>
          <button
            id="dz_overwrite"
            type="button"
            class:dzHidden
            on:click={overwiteFilesClick}>
            Overwite everything
          </button>
          <button id="dz_keepfiles" type="button" class:dzHidden>
            Upload all entries ( keep all existing files)
          </button>
          <button id="dz_cancel" type="button" on:click={destroy}>
            Cancel
          </button>
        </div>
      </div>
      <div class="dz_log" class:dzHidden bind:this={logDiv}>
        {#each messages as message}
          <p>{message}</p>
        {/each}
      </div>
    </label>
    <input
      name="files[]"
      multiple
      type="file"
      id="files_input"
      on:change|preventDefault={drop} />
  </form>
</div>
